import { RequestConfig } from '@src/config/AxiosConfig';

/** This is the value that shows that a business hasn't done onboarding */
export const ONBOARDING_PAGE_STATUS = 1;
// export const ONBOARDING_PAGE_STATUS = 1;

export const API_DOCS_URL = 'https://apidocs.sendsprint.com';

/** Time durations in milliseconds */
export const DURATION_1_SEC = 1000;
export const DURATION_2_SEC = 2 * DURATION_1_SEC;
export const DURATION_5_SEC = 5 * DURATION_1_SEC;
export const DURATION_10_SEC = 10 * DURATION_1_SEC;
export const DURATION_1_MIN = 60 * DURATION_1_SEC;
export const DURATION_3_MIN = 3 * DURATION_1_MIN;
export const DURATION_4_MIN = 4 * DURATION_1_MIN;
export const DURATION_5_MIN = 5 * DURATION_1_MIN;
export const DURATION_10_MIN = 10 * DURATION_1_MIN;
export const DURATION_1_HR = 60 * DURATION_1_MIN;

/** Config to disable API error toasts */
export const CONFIG_NO_ERROR_TOAST: RequestConfig = {
  showToastOnError: false
};

/** Business api version */
export const BUSINESS_API_VERSION = 1;

/** countdown timer for OTP */
export const RESEND_OTP_COUNTDOWN_TIME = 120;

/** Image supported format */
export const IMAGE_SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
export const IMAGE_PDF_SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
];

/** Megabytes */
export const TWO_MB = 1024 * 1024 * 2;

/**Send money max amount */
export const MAXIMUM_AMOUNT_TO_SEND = 5000;

export const CSV_ACCEPT_VALUE =
  '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
export const IMAGE_ACCEPT_VALUE = 'image/*';
export const IMAGE_ACCEPT_VALUE_WITHOUT_SVG = 'image/png, image/gif, image/jpeg';

// Page sizes
export const DEFAULT_PAGE_SIZE = 15;
/**
 * Receivers
 */
export const SETTLEMENT_ACCOUNTS_PAGE_SIZE = DEFAULT_PAGE_SIZE;
export const TRANSACTIONS_PAGE_SIZE = DEFAULT_PAGE_SIZE;
export const SUMMARY_TABLE_PAGE_SIZE = 30;
export const CUSTOMERS_LINKS_PAGE_SIZE = DEFAULT_PAGE_SIZE;
export const PAYMENT_LINKS_PAGE_SIZE = DEFAULT_PAGE_SIZE;
export const PAYMENT_LINKS_TRANSACTIONS_PAGE_SIZE = DEFAULT_PAGE_SIZE;
export const SETTLEMENT_ACCOUNT_TRANSACTIONS_PAGE_SIZE = DEFAULT_PAGE_SIZE;

/**
 * Senders
 */
export const BULK_PAGE_SIZE = DEFAULT_PAGE_SIZE;
export const SINGLE_PAGE_SIZE = DEFAULT_PAGE_SIZE;

/** Payment callback keys */
export const STRIPE_CALLBACK = 'stripe-callback';
export const MODULR_CALLBACK = 'modulr-callback';
export const VOLUME_CALLBACK = 'volume-callback';
export const PAYMENT_CALLBACK = 'payment-callback';

/**Used to store the payment code details to be used if the transactions fails */
export const MODULR_PAYMENT_CODE_KEY = 'mdr-p-code';
export const MODULR_TXREF_CODE_KEY = 'mdr-ref';
export const MODULR_STATUS_CODE_KEY = 'stripe-status';
export const STRIPE_PAYMENT_CODE_KEY = 'stripe-p-code';
export const STRIPE_TXREF_CODE_KEY = 'stripe-ref';
export const STRIPE_STATUS_CODE_KEY = 'stripe-status';
export const VOLUME_PAYMENT_CODE_KEY = 'volume-p-code';
export const VOLUME_TXREF_CODE_KEY = 'volume-ref';

export const PAYMENT_TRANSACTION_TYPE = 'payment-transaction-type';
export const PAYMENT_CODE_KEY = 'payment-code-p-code';
export const PAYMENT_CODE_TXREF_KEY = 'payment-code-ref';
export const PAYMENT_CODE_STATUS_KEY = 'payment-code-status';

/** Tour guide */
export const TOUR_GUIDE_KEY = 'tour-guide';
